export default "__VITE_ASSET__DXIKF2Jl__"